import { useState } from 'react';
import { useMutation, useQuery } from '@apollo/client';
import { useParams } from 'react-router';
import { GET_ROLE_BY_UUID, UPDATE_ROLE } from '../queries';
import { AntModal, Button, Footer, Loading } from '../../../components';
import { RoleByUUID } from './types';
import RolesPermissions from './RolesPermissions';
import TitleBar from '../../../components/TitleBar';
import { Field } from '../../../components/generic/Field';

interface RowProps {
  label: string;
  value: string;
}

const RowDetail = ({ value, label }: RowProps) => (
  <div className="flex gap-2">
    <label className="font-bold w-32">{label}</label>
    <span>{value}</span>
  </div>
);

const RolesDetail = () => {
  const param = useParams();
  const [openModal, setopenModal] = useState(false);

  const { data, loading, error } = useQuery<RoleByUUID>(GET_ROLE_BY_UUID, {
    variables: { uuid: param.roleId },
  });
  const updateGQL = useMutation(UPDATE_ROLE, {
    refetchQueries: ['GetRoleByUuid'],
  });
  const fields: Field[] = [
    {
      label: 'Name',
      key: 'name',
    },
    { label: 'Description', key: 'description' },
  ];

  if (loading) return <Loading />;
  if (error) return <>Error! ${error.message}</>;

  return (
    <div className="flex flex-col gap-3">
      <TitleBar title="Role Details" showFooterSpace={false} />
      <hr />
      <section className="flex flex-col justify-start gap-3">
        <RowDetail label="Name:" value={data?.getRoleByUuid?.name!} />
        <RowDetail
          label="Description:"
          value={data?.getRoleByUuid?.description!}
        />
        {!(
          data?.getRoleByUuid.name === 'admin' ||
          data?.getRoleByUuid.name === 'user'
        ) && (
          <Button
            onClick={() => setopenModal(true)}
            className=" rounded-md border w-28 font-semibold hover:bg-black hover:text-white"
          >
            Edit
          </Button>
        )}
      </section>
      <hr />
      <RolesPermissions panels={data?.getRoleByUuid.panels} />
      <Footer backPath="/roles-management" />
    </div>
  );
};

export default RolesDetail;
